import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useEnvVariable } from "@/composables";

export const useDefaultStore = defineStore("default", () => {
  const { getEnvVar } = useEnvVariable();

  const HOST_ENDPOINT = getEnvVar("HOST_ENDPOINT");
  const MEDIA_ENDPOINT = getEnvVar("MEDIA_ENDPOINT");
  const loadings = ref(0);
  const modals = ref([]);

  const isLoading = computed(() => !!loadings.value);

  function changeLoading(increase = true) {
    if (increase) {
      loadings.value++;
    } else if (loadings.value) {
      loadings.value--;
    }
  }

  return {
    HOST_ENDPOINT,
    MEDIA_ENDPOINT,
    loadings,
    modals,
    isLoading,
    changeLoading,
  };
});
